export const MIN_TITLE = { en: 'Min', th: 'น้อยสุด' }
export const MAX_TITLE = { en: 'Max', th: 'มากสุด' }
